<template>
  <div>
    <b-container v-if="selectedUserSoleProprietorship">
      <section v-if="specialOfferCount !== 0" class="mt-5">
        <b-row class="mt-5">
          <b-col md="12" sm="12" lg="12" xs="12" xl="4">
            <h1 class="text-center">{{ selectedUserSoleProprietorship.soleProprietorshipData.name }}</h1>
          </b-col>
          <b-col xs="12" class="text-left offer-text text-gray-04">
            Gratulálunk! {{ specialOfferCount }} testre szabott lehetőséget találtunk, amellyel egyéni vállalkozását
            fejlesztheti.
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12" sm="12" lg="12" xs="12" xl="4">
            <div
              class="d-flex justify-content-center mx-auto rounded-circle 
              bg-color-green text-white circle-box circle-box"
            >
              <div class="align-self-center">
                <transition name="fade">
                  <div v-if="showAnimatedElements && selectedUserSoleProprietorship">{{ specialOfferCount }}</div>
                </transition>
              </div>
            </div>
          </b-col>
          <b-col md="12" sm="12" lg="12" xs="12" xl="8">
            <b-row class="mt-3 text-left">
              <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="">Másik vállalkozás kiválasztása</label>
                <SelectSoleProprietorship
                  v-if="userSoleProprietorships && userSoleProprietorshipOptions && selectedUserSoleProprietorship"
                />
              </b-col>
            </b-row>
            <b-row class="mt-4" id="offer-list">
              <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                <transition name="slide-fade" v-for="(dbOffer, index) in dbOffers" :key="index">
                  <div
                    class="bg-color-lightblue rounded p-4 mb-4 text-green offer-text text-left offer-badge-holder cursor-pointer"
                    v-if="showAnimatedElements && $store.getters[dbOffer.storeName].length"
                    style="transition-delay: 0.5s;"
                    @click="nextPage(dbOffer.routeName)"
                  >
                    <div
                      class="d-flex justify-content-center rounded-circle bg-color-green text-white circle-mini-box float-left mr-3"
                    >
                      <div class="align-self-center">
                        {{ $store.getters[dbOffer.storeName].length }}
                      </div>
                    </div>
                    {{ dbOffer.name }}
                  </div>
                </transition>
              </b-col>
              <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                <div
                  class="bg-color-lightblue rounded p-4 mb-4 text-green offer-text text-left cursor-pointer offer-badge-holder"
                  @click="openLinkNewTab(offer.link)"
                  v-for="(offer, index) in constantCompanyOffers"
                  :key="index"
                >
                  <component :is="offer.componentName" class="offer-badge-svg"></component>
                  {{ offer.name }}
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <ConsultantOpportunities class="mt-4 mb-5" />
      </section>
      <section v-else>
        <b-row class="mt-3 offer-row" cols="1">
          <strong>Ehhez az egyéni vállalkozáshoz aktuálisan nem található lehetőség!</strong>
        </b-row>
      </section>
    </b-container>
    <b-container v-else>
      Nem található Hozzárendelt cég!
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SelectSoleProprietorship from '../components/SelectSoleProprietorship.vue'
import CertifiedExpertsSvg from '../components/svg/CompanyOffers/CertifiedExperts'
import ModernFactoriesSvg from '../components/svg/CompanyOffers/ModernFactories'
import SchoolSvg from '../components/svg/CompanyOffers/School'
import ConsultancySvg from '../components/svg/CompanyOffers/Consultancy'
import openLinkNewTab from '../mixins/openLinkNewTab'
import constantCompanyOffers from '../mixins/constantCompanyOffers'
import SmeClassificationInformation from '@/components/SmeClassificationInformation.vue'
import ConsultantOpportunities from './Opportunities/ConsultantOpportunities.vue'
export default {
  name: 'PrivateSoleProprietorshipOffers',
  mixins: [openLinkNewTab, constantCompanyOffers],
  components: {
    SmeClassificationInformation,
    SelectSoleProprietorship,
    CertifiedExpertsSvg,
    ModernFactoriesSvg,
    SchoolSvg,
    ConsultancySvg,
    ConsultantOpportunities
  },
  data() {
    return {
      showAnimatedElementsInit: false,
      dbOffers: [
        {
          routeName: 'CREDIT',
          storeName: 'competitionCredits',
          name: 'Támogatott hitel'
        },
        {
          routeName: 'APPLICATION',
          storeName: 'competitionApplications',
          name: 'Támogatás'
        },
        {
          routeName: 'GUARANTEE',
          storeName: 'competitionGuarantees',
          name: 'Hitelgarancia'
        },
        {
          routeName: 'CAPITAL_PRODUCT',
          storeName: 'competitionCapitalProducts',
          name: 'Tőkeprogram'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'selectedUserSoleProprietorship',
      'userSoleProprietorships',
      'competitionApplications',
      'competitionCredits',
      'competitionGuarantees',
      'competitionCapitalProducts',
      'isAuthenticated',
      'isLoading',
      'totalCount',
      'userSoleProprietorshipOptions'
    ]),
    showAnimatedElements() {
      return !this.isLoading && this.showAnimatedElementsInit
    },
    specialOfferCount() {
      return (
        this.competitionApplications.length +
        this.competitionCredits.length +
        this.competitionGuarantees.length +
        this.competitionCapitalProducts.length
      )
    },
    triggeredTypeCount() {
      if (this.competitionApplications.length && this.competitionCredits.length) {
        return 2
      } else if (this.competitionApplications.length || this.competitionCredits.length) {
        return 1
      } else {
        return 0
      }
    }
  },
  async mounted() {
    if (!this.selectedUserSoleProprietorship) {
      if (this.$route.query.soleProprietorshipId == null) {
        if (this.isAuthenticated) this.$router.push('/home')
        else this.$push('/')
        return
      }

      await this.$store.dispatch('getUserSoleProprietorships', {})
      this.$store.commit(
        'setSelectedUserSoleProprietorship',
        this.userSoleProprietorships.find(
          x => x.soleProprietorshipId === parseInt(this.$route.query.soleProprietorshipId)
        )
      )
      await this.$store.dispatch('getCompetitionsSoleProprietorship', {
        soleProprietorshipId: parseInt(this.$route.query.soleProprietorshipId)
      })
    } else {
      await this.$store.dispatch('getCompetitionsSoleProprietorship', {
        soleProprietorshipId: this.selectedUserSoleProprietorship.soleProprietorshipId
      })
    }
    this.showAnimatedElementsInit = true

    this.$gtag.event('sole_proprietorship_offers_private', {
      event_category: 'user_interaction',
      soleProprietorshipId: this.selectedUserSoleProprietorship.soleProprietorshipId
    })
  },
  methods: {
    nextPage(type) {
      this.$router.push(
        `sole-proprietorship-offerlist?userSoleProprietorshipId=${this.selectedUserSoleProprietorship._id}&type=${type}`
      )
    }
  }
}
</script>

<style scoped>
.circle-box {
  box-shadow: 0px 0px 0px 15px var(--color-lightgreen);
  font-size: 80px;
  width: 200px;
  height: 200px;
  font-weight: bold;
  margin-top: 4.5rem;
  margin-bottom: 3rem;
}

.circle-mini-box {
  width: 50px;
  height: 50px;
  margin-top: -7px;
}

.offer-badge-holder {
  height: 85px;
}

.offer-badge-svg {
  margin-right: 10px;
}

.offer-text {
  font-size: 24px;
}
</style>
